import React, { FC, useState } from "react";
import { Dimensions, Measure } from "components/List/Measure";
import { PAGING_BUTTON_WIDTH } from "./sizes";
import { TruncatedPageButtons } from "./TruncatedPageButtons";
import { IconButton } from "@xapp/components";
import PageSelectorStyle from "./selectorStyle.scss";

export interface PageSelectorProps {
    readonly totalPages: number;
    readonly selectedPage: number;
    onPageChange(page: number): void;
}

export const PageSelector: FC<PageSelectorProps> = ({
    totalPages,
    onPageChange,
    selectedPage
}: PageSelectorProps) => {

    const [maxWidth, setMaxWidth] = useState<number>(Number.MAX_SAFE_INTEGER);


    if (totalPages < 2) {
        return <div style={{ visibility: "hidden" }} />;
    }

    function goFirst() {
        onPageChange(1);
    }

    function goPrev() {
        onPageChange(Math.max(selectedPage - 1, 1));
    }

    function goNext() {
        onPageChange(Math.min(selectedPage + 1, totalPages));
    }

    function goLast() {
        onPageChange(totalPages);
    }

    function handleResize(dimens: Dimensions) {
        setMaxWidth(dimens.width);
    }

    const slots = Math.max(0, Math.floor(maxWidth / PAGING_BUTTON_WIDTH) - 4);

    return (
        <Measure onMeasure={handleResize} className={PageSelectorStyle.pages}>
            <div className={PageSelectorStyle.container}>
                <IconButton
                    // theme={PageSelectorStyle}
                    iconName="skip_previous"
                    onClick={goFirst} />
                <IconButton
                    // theme={PageSelectorStyle}
                    iconName={"keyboard_arrow_left"}
                    onClick={goPrev}
                />
                <TruncatedPageButtons
                    totalPages={totalPages}
                    selectedPage={selectedPage}
                    slots={slots}
                    onPageSelected={onPageChange}
                />
                <IconButton
                    // theme={PageSelectorStyle}
                    iconName={"keyboard_arrow_right"}
                    onClick={goNext}
                />
                <IconButton
                    // theme={PageSelectorStyle}
                    iconName={"skip_next"}
                    onClick={goLast}
                />
            </div>
        </Measure>
    );
};
